import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {AdminReview, NewReview, ReviewSummary} from "../../models/review";

@Injectable({
    providedIn: 'root'
})
export class ReviewService {

    private readonly url = environment.domain.backend + '/reviews';
    private readonly adminUrl = environment.domain.backend + '/admin/reviews';

    constructor(private readonly http: HttpClient) {
    }

    forProduct(productId: number): Observable<ReviewSummary> {
        return this.http.get<ReviewSummary>(`${this.url}/product/${productId}`);
    }

    latest(limit: number): Observable<ReviewSummary> {
        return this.http.get<ReviewSummary>(`${this.url}/latest?limit=${limit}`);
    }

    submit(review: NewReview): Observable<void> {
        return this.http.post<void>(this.url, review);
    }

    all(): Observable<AdminReview[]> {
        return this.http.get<AdminReview[]>(this.adminUrl);
    }

    create(review: AdminReview): Observable<AdminReview> {
        return this.http.post<AdminReview>(this.adminUrl, review);
    }

    update(review: AdminReview): Observable<AdminReview> {
        return this.http.put<AdminReview>(`${this.adminUrl}/${review.id}`, review);
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.adminUrl}/${id}`);
    }
}
